/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Continue_TrialInputs */



/**
* | output |
* | --- |
* | "Continue Trial" |
*
* @param {Batch_Subtitle_Export_Continue_TrialInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_continue_trial = /** @type {((inputs?: Batch_Subtitle_Export_Continue_TrialInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Continue_TrialInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer l’essai")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortsetzung des Verfahrens")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua la prova")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжить судебное разбирательство")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar la prueba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续审判")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トライアルを続ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सतत् परीक्षण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar o julgamento")
	return /** @type {LocalizedString} */ ("Continue Trial")
});